(function(){
    "use strict";

    angular.module('SmartAdmin.Forms', []);
})();